// src/components/reservation/ContactSheet.js
// BottomSheet de contact - utilise le numéro public propre à chaque annonce - NE PAS MODIFIER

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../hooks/useTheme';
import { APP_CONFIG } from '../../constants/config';

const ContactSheet = ({ open, onClose, contactPhone, listingTitle, listingSlug }) => {
  const { t } = useTranslation();
  const { theme } = useTheme();

  if (!open) return null;

  // Utilise le numéro spécifique de l'annonce s'il existe, sinon repli sur le support général
  const activePhone = contactPhone || APP_CONFIG.SUPPORT_WHATSAPP;
  const cleanPhone = activePhone.replace(/\D/g, '');
  const listingUrl = listingSlug ? `${window.location.origin}/listing/${listingSlug}` : '';

  const handleWhatsApp = () => {
    const message = encodeURIComponent(
      `Bonjour, je suis intéressé(e) par cette annonce sur Fynho : "${listingTitle}".\n\n${listingUrl}`
    );
    window.open(`https://wa.me/${cleanPhone}?text=${message}`, '_blank');
    onClose();
  };

  const handleCall = () => {
    window.location.href = `tel:+${cleanPhone}`;
    onClose();
  };

  const styles = {
    backdrop: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      zIndex: 2000,
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'center',
      animation: 'fadeIn 200ms ease-out',
    },
    sheet: {
      width: '100%',
      maxWidth: '480px',
      backgroundColor: theme.bgCard,
      borderTopLeftRadius: '20px',
      borderTopRightRadius: '20px',
      padding: '12px 20px calc(24px + env(safe-area-inset-bottom, 0px))',
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      animation: 'slideUpSheet 250ms ease-out',
      borderTop: `1px solid ${theme.border}`,
    },
    handle: {
      width: '40px',
      height: '4px',
      borderRadius: '2px',
      backgroundColor: theme.textMuted,
      margin: '4px auto 8px',
    },
    title: {
      fontSize: '17px',
      fontWeight: '700',
      color: theme.textPrimary,
      textAlign: 'center',
    },
    subtitle: {
      fontSize: '13px',
      color: theme.textSecondary,
      textAlign: 'center',
      marginTop: '-8px',
    },
    button: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '10px',
      padding: '16px',
      borderRadius: '12px',
      border: 'none',
      fontSize: '16px',
      fontWeight: '700',
      cursor: 'pointer',
    },
    whatsappBtn: {
      backgroundColor: '#25D366',
      color: '#FFFFFF',
    },
    whatsappHint: {
      fontSize: '11px',
      color: theme.textMuted,
      textAlign: 'center',
      marginTop: '-8px',
    },
    callBtn: {
      backgroundColor: theme.bgInput,
      color: theme.textPrimary,
      border: `1px solid ${theme.border}`,
    },
    cancelBtn: {
      background: 'none',
      border: 'none',
      color: theme.textSecondary,
      fontSize: '15px',
      fontWeight: '600',
      cursor: 'pointer',
      padding: '8px',
    },
  };

  return (
    <div style={styles.backdrop} onClick={onClose}>
      <style>{`
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUpSheet {
          from { transform: translateY(100%); }
          to { transform: translateY(0); }
        }
      `}</style>
      <div style={styles.sheet} onClick={(e) => e.stopPropagation()}>
        <div style={styles.handle} />
        <div style={styles.title}>{t('listing.contact')}</div>
        <div style={styles.subtitle}>{listingTitle}</div>

        <button
          style={{ ...styles.button, ...styles.whatsappBtn }}
          onClick={handleWhatsApp}
        >
          💬 WhatsApp
        </button>
        <div style={styles.whatsappHint}>Le lien de l'annonce sera inclus automatiquement</div>

        <button
          style={{ ...styles.button, ...styles.callBtn }}
          onClick={handleCall}
        >
          📞 {t('listing.phone')}
        </button>

        <button style={styles.cancelBtn} onClick={onClose}>
          {t('common.cancel')}
        </button>
      </div>
    </div>
  );
};

export default ContactSheet;